import type { OrderResponse } from '@repo/shared/dto'

// Re-export DTOs from @repo/shared (browser-safe)
export * from '@repo/shared/dto'
// Re-export Prismabox from @repo/shared (browser-safe TypeBox schemas)
export * as Prismabox from '@repo/shared/prismabox/barrel'
export * from './test-utils'
export * from './inMemoryQueue'

export const Role = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const

export type Role = (typeof Role)[keyof typeof Role]

export type Order = OrderResponse
